module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filter":"Filter","code_stdout":"Standard output","use_project_code":"Use project code"},"fr":{"filter":"Filtre","code_stdout":"Sortie standard","use_project_code":"Utiliser le code spécifique au projet"}}')
  delete Component.options._Ctor
}
